export default __webpack_public_path__ + "static/media/Intry-Logo-Small.a8edf222.png";